export default function HeroSection() {
  return (
    <section className="bg-white pt-24 pb-14 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        {/* Left */}
        <div className="flex flex-col gap-5">
          <div className="inline-flex items-center gap-2 self-start">
            <span className="h-1.5 w-6 bg-[#2563EB] rounded-full"></span>
            <span
              className="text-xs font-semibold tracking-widest uppercase text-[#2563EB]"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Cordycep Militaris Extract
            </span>
          </div>

          <h1
            className="text-[#0F172A] leading-[1.0] text-5xl xl:text-6xl"
            style={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 900,
              letterSpacing: '-0.05em',
            }}
          >
            Absolute Cordycepin Control
          </h1>

          <p
            className="text-[#475569] text-base leading-relaxed max-w-lg"
            style={{ fontFamily: 'Inter, sans-serif', fontWeight: 400 }}
          >
            Forage Fuel&apos;s proprietary ingredient Cordymax™ is the industry&apos;s first modular Cordyceps militaris extract.
            Dial in your therapeautic dose from 1% to 10% standardized cordycepin.
          </p>

          <div className="flex flex-wrap items-center gap-3 pt-1">
            <a
              href="tel:9548655411"
              className="bg-[#2563EB] text-white text-sm font-semibold px-6 py-3 rounded-md hover:bg-[#1d4ed8] transition-colors whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Contact
            </a>
            <a
              href="#specs"
              className="border border-[#E2E8F0] text-[#0F172A] text-sm font-semibold px-6 py-3 rounded-md hover:bg-[#F8F9FA] transition-colors whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              View Technical Specs
            </a>
          </div>

          <div className="flex items-center gap-6 pt-2 border-t border-[#E2E8F0]">
            <div>
              <p
                className="text-2xl text-[#0F172A]"
                style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900, letterSpacing: '-0.04em' }}
              >
                1-10%
              </p>
              <p className="text-xs text-[#475569]" style={{ fontFamily: 'Inter, sans-serif' }}>
                Cordycepin Range
              </p>
            </div>
            <div className="h-8 w-px bg-[#E2E8F0]"></div>
            <div>
              <p
                className="text-2xl text-[#0F172A]"
                style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900, letterSpacing: '-0.04em' }}
              >
                100%
              </p>
              <p className="text-xs text-[#475569]" style={{ fontFamily: 'Inter, sans-serif' }}>
                Water Soluble
              </p>
            </div>
            <div className="h-8 w-px bg-[#E2E8F0]"></div>
            <div>
              <p
                className="text-2xl text-[#0F172A]"
                style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900, letterSpacing: '-0.04em' }}
              >
                COA
              </p>
              <p className="text-xs text-[#475569]" style={{ fontFamily: 'Inter, sans-serif' }}>
                Full Panel Verified
              </p>
            </div>
          </div>
        </div>

        {/* Right */}
        <div className="relative w-full h-[420px] lg:h-[480px] rounded-xl overflow-hidden border border-[#E2E8F0]">
          <img
            src="https://static.readdy.ai/image/8913734a70cbb1a241150d09a7ce58bf/f9e0971c4904631d642366e621549ca2.png"
            alt="Cordymax Lab Extract"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/20 to-transparent"></div>
          <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm border border-[#E2E8F0] rounded-md px-3 py-2">
            <p
              className="text-xs text-[#0F172A]"
              style={{ fontFamily: 'Inter, sans-serif', fontWeight: 700 }}
            >
              Cordymax™ — Standardized Extract
            </p>
            <p className="text-xs text-[#475569]" style={{ fontFamily: 'Inter, sans-serif' }}>
              GMP Certified · Full Panel COA
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
